import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    Button,
    Label,
} from "reactstrap";
import {
    getDate,
    getFirstday
} from "../../helpers/globalFunctions";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import Select from "react-select";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import "./style.scss";
const FollowupReport = () => {
    const API_URL = process.env.REACT_APP_APIURL || "http://localhost:3099/";
    const [followupData, setFollowupData] = useState([]);
    const [searchData, setSearchData] = useState({
        from_date: getFirstday(new Date()),
        to_date: getDate(new Date()), category: 1,
        categoryObject: { label: 'Candidate', value: 1 }
    });
    const [selectedCategory, setSelectedCategory] = useState({ label: "Candidate", value: 1 })
    const fetch_data = (from_date = getFirstday(new Date()), to_date = getDate(new Date()), category = 1) => {
        axios
            .get(`${API_URL}followup/report?&from_date=${from_date}&to_date=${to_date}&type=${category}`, {
                headers: {
                    "x-access-token": accessToken,
                },
            })
            .then((res) => {
                let result = res.data.data;
                let Data = [];
                result.map((item, indx) => {
                    item.added_by = item.staffName;
                    item.total = item.totalCount;
                    item.statuses.map((el, indx) => {

                        // item.status1 = el.name === 'WILLING' ? el.count : 0;
                        // item.status2 = el.name === 'APPLIED' ? el.count : 0;
                        // item.status3 = el.name === 'APPOINTED' ? el.count : 0;
                        // item.status4 = el.name === 'LOCAL' ? el.count : 0;
                        // item.status5 = el.name === 'ONLINE' ? el.count : 0;
                        // item.status6 = el.name === 'CANCELLED' ? el.count : 0;
                        // item.status7 = el.name === 'PENDING' ? el.count : 0;
                        // item.status8 = el.name === 'NOT AVAILABLE' ? el.count : 0;
                        // item.status9 = el.name === 'UNDER PROCESS' ? el.count : 0;

                        if (el.name === 'WILLING') {
                            item.status1 = el.count;
                        } else if (el.name === 'APPLIED') {
                            item.status2 = el.count;
                        } else if (el.name === 'APPOINTED') {
                            item.status3 = el.count;
                        } else if (el.name === 'LOCAL') {
                            item.status4 = el.count;
                        } else if (el.name === 'ONLINE') {
                            item.status5 = el.count;
                        } else if (el.name === 'CANCELLED') {
                            item.status6 = el.count;
                        } else if (el.name === 'PENDING') {
                            item.status7 = el.count;
                        } else if (el.name === 'NOT AVAILABLE') {
                            item.status8 = el.count;
                        } else if (el.name === 'UNDER PROCESS') {
                            item.status9 = el.count;
                        }

                        // institute
                        if (el.name === 'WRONG ENTRY OF CANDIDATE') {
                            item.status1 = el.count;
                        } else if (el.name === 'ONLY LOCAL HIRING') {
                            item.status2 = el.count;
                        } else if (el.name === 'NOT INTERESTED') {
                            item.status3 = el.count;
                        } else if (el.name === 'WILL HIRE LATER') {
                            item.status4 = el.count;
                        } else if (el.name === 'READY TO HIRE NOW') {
                            item.status5 = el.count;
                        } else if (el.name === 'ONLY RECRUIT WITH SUPPORT') {
                            item.status6 = el.count;
                        } else if (el.name === 'FRAUD') {
                            item.status7 = el.count;
                        } else if (el.name === 'AGENCY') {
                            item.status8 = el.count;
                        } else if (el.name === 'POOR INFRASTRUCTURE') {
                            item.status9 = el.count;
                        } else if (el.name === 'IRRELEVANT ENTRY') {
                            item.status10 = el.count;
                        } else if (el.name === 'NOT AVAILABLE') {
                            item.status11 = el.count;
                        }


                    })
                    Data.push(item)
                })
                setFollowupData(Data);
            });
    }
    const data = {
        columns: [
            {
                label: "Staff",
                field: "added_by",
                sort: "asc",
                width: 150,
            },
            {
                label: "WILLING",
                field: "status1",
                sort: "asc",
                width: 150,
            },
            {
                label: "APPLIED",
                field: "status2",
                sort: "asc",
                width: 150,
            },
            {
                label: "APPOINTED",
                field: "status3",
                sort: "asc",
                width: 150,
            }, {
                label: "LOCAL",
                field: "status4",
                sort: "asc",
                width: 150,
            }, {
                label: "ONLINE",
                field: "status5",
                sort: "asc",
                width: 150,
            }, {
                label: "CANCELLED",
                field: "status6",
                sort: "asc",
                width: 150,
            }, {
                label: "PENDING",
                field: "status7",
                sort: "asc",
                width: 150,
            }, {
                label: "NOT AVAILABLE",
                field: "status8",
                sort: "asc",
                width: 150,
            }, {
                label: "UNDER PROCESS",
                field: "status9",
                sort: "asc",
                width: 150,
            },
            {
                label: "TOTAL",
                field: "total",
                sort: "asc",
                width: 150,
            },

        ],
        rows: followupData,
    };
    const instdata = {
        columns: [
            {
                label: "Staff",
                field: "added_by",
                sort: "asc",
                width: 150,
            },
            {
                label: "WRONG ENTRY OF CANDIDATE",
                field: "status1",
                sort: "asc",
                width: 150,
            },
            {
                label: "ONLY LOCAL HIRING",
                field: "status2",
                sort: "asc",
                width: 150,
            },
            {
                label: "NOT INTERESTED",
                field: "status3",
                sort: "asc",
                width: 150,
            }, {
                label: "WILL HIRE LATER",
                field: "status4",
                sort: "asc",
                width: 150,
            }, {
                label: "READY TO HIRE NOW",
                field: "status5",
                sort: "asc",
                width: 150,
            }, {
                label: "ONLY RECRUIT WITH SUPPORT",
                field: "status6",
                sort: "asc",
                width: 150,
            }, {
                label: "FRAUD",
                field: "status7",
                sort: "asc",
                width: 150,
            }, {
                label: "AGENCY",
                field: "status8",
                sort: "asc",
                width: 150,
            }, {
                label: "POOR INFRASTRUCTURE",
                field: "status9",
                sort: "asc",
                width: 150,
            }, {
                label: "IRRELEVANT ENTRY",
                field: "status10",
                sort: "asc",
                width: 150,
            }, {
                label: "NOT AVAILABLE",
                field: "status11",
                sort: "asc",
                width: 150,
            },
            {
                label: "TOTAL",
                field: "total",
                sort: "asc",
                width: 150,
            },

        ],
        rows: followupData,
    };

    const handleFollowFilter = (selected, type) => {
        const category = searchData?.category ? searchData?.category : "";

        switch (type) {
            case "from_date":
                if (selected.target.value > searchData?.to_date)
                    var to_date = selected.target.value;
                else
                    var to_date = searchData?.to_date;
                setSearchData({ ...searchData, "from_date": selected.target.value, "to_date": to_date });
                fetch_data(selected.target.value, to_date, category)
                break;
            case "to_date":
                if (selected.target.value < searchData?.from_date)
                    var from_date = selected.target.value;
                else
                    var from_date = searchData?.from_date;
                setSearchData({ ...searchData, "to_date": selected.target.value, "from_date": from_date });
                fetch_data(from_date, selected.target.value, category)
                break;
            case "category":
                setSelectedCategory(selected)
                setSearchData({
                    ...searchData,
                    category: selected.value,
                    categoryObject: selected
                })
                fetch_data(from_date, to_date, selected.value)
                break;
        }

    }
    const resetFollowupFilter = (value) => {
        fetch_data();
        setSearchData({
            from_date: getFirstday(new Date()),
            to_date: getDate(new Date()),
            category: 1,
            categoryObject: { label: "Candidate", value: 1 }
        });
    }


    useEffect(() => {
        fetch_data();
    }, []);



    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Followup Report" />

                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>

                                    <Row className="mb-2">

                                        <Col md="2">
                                            <div>
                                                <Label htmlFor="validationCustom05">From</Label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    id="from_date"
                                                    name="from_date"
                                                    value={searchData?.from_date}
                                                    onChange={(e) => {
                                                        handleFollowFilter(e, "from_date");
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col md="2">
                                            <div >
                                                <Label htmlFor="validationCustom05">To</Label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    id="to_date"
                                                    name="to_date"
                                                    value={searchData?.to_date}
                                                    onChange={(e) => {
                                                        handleFollowFilter(e, "to_date");
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col md="2">
                                            <Label>Followup Category</Label>
                                            <Select
                                                name="category"
                                                options={[
                                                    { label: "Candidate", value: 1 },
                                                    { label: "Institute", value: 2 }
                                                ]}
                                                value={searchData?.categoryObject}
                                                onChange={(selected) => {
                                                    handleFollowFilter(selected, 'category')
                                                }}
                                            />
                                        </Col>

                                        <Col md="1" style={{ marginTop: "2.5%" }}>
                                            <div className="mb-3">

                                                <Button color="danger" type="reset" onClick={resetFollowupFilter}>
                                                    {"Reset"}
                                                </Button>
                                            </div>
                                        </Col>

                                    </Row>
                                    {searchData?.category === 1 ? (
                                        <MDBDataTable
                                            id="followupReport"
                                            responsive
                                            bordered
                                            data={data}
                                            searching={true}
                                            disableRetreatAfterSorting={true}
                                            entries={25}
                                        />
                                    ) : (
                                        <MDBDataTable
                                            id="followupReport"
                                            responsive
                                            bordered
                                            data={instdata}
                                            searching={true}
                                            disableRetreatAfterSorting={true}
                                            entries={25}
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )

}


export default FollowupReport;